import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=64102336&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64102336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64102336')) {
      api.createRecord('64102336', component.options)
    } else {
      api.reload('64102336', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=64102336&scoped=true&", function () {
      api.rerender('64102336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/_template2/Index.vue"
export default component.exports